//
//
//

export default {
	name: 'logoMobile',
}
